if (!File.prototype.toBase64) {
    File.prototype.toBase64 = function () {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(this)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
        })
    }
}
